import React from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { ContactInfo, ContactContent, InterestOption } from '../types';

export const contactContent: ContactContent = {
  heading: 'Get in Touch',
  description: 'Ready to transform your business with intelligent agentic systems? Contact us today to discuss how we can help you innovate and optimize.'
};

export const contactInfoItems: ContactInfo[] = [
  {
    icon: React.createElement(FaEnvelope),
    title: 'Email',
    content: '1@az1.ai',
    link: 'mailto:1@az1.ai',
  },
  {
    icon: React.createElement(FaPhone),
    title: 'Phone',
    content: '+1 (415) 299-2919',
    link: 'tel:+14152992919',
  },
  {
    icon: React.createElement(FaMapMarkerAlt),
    title: 'Location',
    content: 'Corte Madera, CA',
  },
];

export const interestOptions: InterestOption[] = [
  { value: 'agent-development', label: 'Agent Development' },
  { value: 'multi-agent-systems', label: 'Multi-Agent Systems' },
  { value: 'cognitive-architecture', label: 'Cognitive Architecture' },
  { value: 'deployment', label: 'Deployment Infrastructure' },
  { value: 'integration', label: 'System Integration' },
  { value: 'other', label: 'Other' },
];